<mat-dialog-content #dialogContainer>
    <auth-form [title]="title"
               [image]="image"
               [nextUrl]="nextUrl ?? ''"
               [defaultNextUrl]="defaultNextUrl??''"
               [isRegistrationDisabled]="isRegistrationDisabled">
    </auth-form>
</mat-dialog-content>
